import { render, staticRenderFns } from "./pos-confirm-payment-modal.vue?vue&type=template&id=65423382&scoped=true&"
import script from "./pos-confirm-payment-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-confirm-payment-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65423382",
  null
  
)

export default component.exports